<template>
  <td v-if="renderCell" class="selection-template" :class="className">
    <input :class="{ 'k-radio': single, 'k-checkbox': !single }" :type="single ? 'radio' : 'checkbox'" :name="finalTableId" :checked="dataItem[field]" @change="$emit('selectionchange', { event: $event, dataItem })" @click.stop="selectClick" />
  </td>
  <td v-else-if="renderArrow" :key="`g-${columnIndex}`" class="k-group-cell" :class="className" />
  <td v-else-if="renderGroup" key="g-colspan" class="selection-template" :colSpan="columnsCount - columnIndex" :class="className">
    <p class="k-reset">
      <a @click="$emit('click', $event, dataItem, expanded)" tabIndex="-1" href="#" class="k-icon" :class="expanded ? 'k-i-collapse' : 'k-i-expand'" />
      {{ groupHeader }}
    </p>
  </td>
</template>
<script>
import getNestedValue from '@/services/functions/getNestedValue'
import { discard } from '@/services/functions/preserve&discard'
import NULL from '@/constants/NULL'

export default {
  name: 'selection-template',
  props: {
    tableId: [String, Number],
    field: String,
    dataItem: Object,
    format: String,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String,
    type: {
      type: String,
      default: 'Text'
    },
    extraparams: {
      type: Object,
      default: () => ({})
    },
    selectedField: String,
    single: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    finalTableId: function () {
      const prefix = this.single ? 'k-radio' : 'k-checkbox'
      return `${prefix}-${this.field}-${this.tableId}`
    },
    renderArrow () {
      var returnValue =
        this.columnIndex === undefined ||
        this.level === undefined ||
        this.columnIndex < this.level ||
        this.columnsCount === undefined ||
        this.rowType !== 'groupHeader' ||
        this.dataItem[this.field] === undefined
      // return returnValue && this.dataItem[this.field]
      return returnValue && this.dataItem[this.field] !== undefined
    },
    renderCell () {
      return this.field !== undefined && this.rowType !== 'groupHeader'
    },
    renderGroup () {
      return this.columnIndex <= this.level
    },
    value: function () {
      const value = getNestedValue(this.field, this.dataItem)
      return value === NULL ? null : value
    },
    groupHeader () {
      const value = this.value
      if (this.rowType === 'groupHeader') {
        const template = this.extraparams.groupHeaderTemplate
        if (typeof template === 'function') {
          return template(this.dataItem, { value, ...discard([template.name], this.extraparams) })
        }
      }
      if (value === null || value === undefined) return '' 
      return value 
    },
    isSelected: function () {
      return getNestedValue(this.selectedField, this.dataItem)
    },
    isSelectColumn: function () {
      return this.selectedField === this.field
    }
  },
  methods: {
    selectClick: function (event) {
      if (this.single && this.isSelectColumn && this.isSelected) {
        this.$emit('selectionchange', { event: event, dataItem: this.dataItem })
      }
    }
  },
}
</script>

<style scoped>
.bg-success-p{
  background-color: black;
}
</style>
